import { z } from 'zod';

export const FormSchema = z.object({
  ma_phi: z.string().min(1, { message: 'Mã phí không được để trống' }),
  ten_phi: z.string().min(1, { message: 'Tên phí không được để trống' }),
  ten_khac: z.string().min(1, { message: 'Tên phí không được để trống' }),
  trang_thai: z.number().min(0, { message: 'Trạng thái không được để trống' }).default(1)
});

export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  ma_phi: '',
  ten_phi: '',
  ten_khac: '',
  trang_thai: 1
};
